<template>
    <div style="padding: 0px 3%;">
        <el-form :model="from" :rules="rules" ref="ruleForm" label-width="170px">
            <div>
                <el-divider content-position="left">
                    <h2 style="color: #006E4B;">身份证</h2>
                </el-divider>
                <el-row style="margin-top: 20px;">

                    <el-col :span="6" style="margin-bottom: 10px;">
                        <div
                            style=" width: 90%; border: 1px solid #e9e9e9; border-radius: 5px; padding: 0 10px; height: 100px;">
                            <el-row>
                                <el-col :span="6" style="margin: 13px 0px;">
                                    <img src="../../../../assets/icon/文件类型-附件@2x.png" width="65px" height="73px" />
                                </el-col>
                                <el-col :span="12" style="margin: 30px 0px;">
                                    <span>王梦琪-身份证附件.jpg</span>
                                    <br />
                                    <span style="font-size: 15px; color: #929292;">32kb</span>
                                </el-col>
                                <el-col :span="6" style="margin: 36px 0px;">
                                    <el-button size="mini"
                                        style="background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                        下载附件</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>

                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["from"],
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// accessory.vue?542a37d7